module.exports = new __parcel__URL__("warning.580c5328.svg").toString();